<template>
  <div class="fixed left-0 top-0 h-screen w-screen bg-cover">
    <div class="h-screen w-screen flex flex-col overflow-y-scroll">
      <div class="w-full p-4 text-slate-500">
        <a-avatar
          :src="
            userStore.current?.avatar ||
            'https://res-cn.makeblock.com/passport/official/avatar/1.png'
          "
          :size="36"
        />
        <span class="ml-2">{{ userStore.current?.realName }}</span>
      </div>
      <div class="mx-6">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useUserStore } from '@/store';

const userStore = useUserStore();
</script>
